import React from "react";
import { useTranslation } from "react-i18next";

export const LoadingSpinner = ({show}) => {
    const { t } = useTranslation();

    if (!show) return null;

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.1)', zIndex: 9999 }}>
            {/* <Spinner animation="border" variant="primary" /> */}
            <div className="spinner-border primary" role="status" id="appSpinner">
                <span className="visually-hidden">{t('common.loading')}</span>
            </div>
        </div>
    );
};
